export default {
  methods: {
    setActiveStep(step) {
      this.$emit('set-active-step', step);
    },
  }
}